import {
  Agent_Header_Icon,
  Agentic_Header_Icon,
  AI_Academy_Icon,
  AI_Core_Icon,
  AI_Platform_Product_Img,
  Analytics_Engine_Header_Icon,
  Article_Header_Icon,
  Autonomous_Agent_Icon,
  Capital_Market_Icon,
  Career_Header_Icon,
  Contact_Header_icon,
  DA_Header_Icon,
  // Data_Access_Img,
  Data_Asistant_Product,
  // Digital_Analytics_Header_Icon,
  Enterprises_Header_Icon,
  Event_Header_Icon,
  FAQs_Header_Icon,
  Financial_Header_Icon,
  Hardware_accelerated_Icon,
  Infrastructure_Header_Icon,
  // Innovative_Img,
  Partnership_Icon,
  PLLM_Hero_Img,
  PLM_Header_Icon,
  // Pulse_Header_Icon,
  Pulse_Product_img,
  Purpose_Built_Icon,
  // Real_Time_Img,
  // Secure_Header_Icon,
  // Simplified_Data_Img,
  Team_Header_Icon,
  Trade_Assistant_Img,
  Trade_Icon,
  Vertically_Integrated_Icon,
} from "../../assets";

export const productsSliderData = [
  {
    product_name: "[AI] Platform",
    paragraph:
      "Managed cloud infrastructure powered by Speedata APU and NVIDIA GPU clusters. Cloud or on-premise for data sovereignty.",
    link: "/ai-platform",
    image: AI_Platform_Product_Img,
    discipline: "Analytics",
  },
  {
    product_name: "Pulse",
    paragraph:
      "Behavioural and event-based data collection for web, mobile, and server. Purpose-built for analytics and the context layer for the agentic era.",
    link: "/pulse",
    image: Pulse_Product_img,
    discipline: "Analytics",
  },
  {
    product_name: "CORE",
    paragraph:
      "A family of fine-tuned small language models for analytics reasoning. From lightweight inference to deep causal analysis to quant-specialised financial reasoning.",
    link: "/pllm",
    image: PLLM_Hero_Img,
    discipline: "Intelligence",
  },
  {
    product_name: "Data Assistant",
    paragraph:
      "Autonomous agent for digital analytics teams. Monitors data, surfaces insights, and takes controlled actions, before you ask.",
    link: "/data-assistant",
    image: Data_Asistant_Product,
    discipline: "Analytics + Intelligence Applied",
  },
  {
    product_name: "TradeTutor",
    paragraph:
      "Autonomous agent for quantitative traders and algorithm developers. Backtests strategies, evaluates signals, and reasons through what works and why.",
    link: "/tradetutor",
    image: Trade_Assistant_Img,
    discipline: "Analytics + Intelligence Applied",
  },
];

export const whyChooseUs = [
  {
    title: "Vertically integrated, from silicon to agent",
    text: "Every layer of the stack, data collection, processing engine, query language, AI models, and autonomous agents is built by us and optimised end-to-end.",
    img: Vertically_Integrated_Icon,
  },
  {
    title: "Purpose-built AI, not a general-purpose wrapper",
    text: "CORE is a family of fine-tuned small language models with chain-of-thought reasoning, trained specifically for analytics interpretation and quantitative finance.",
    img: Purpose_Built_Icon,
  },
  {
    title: "Hardware-accelerated performance",
    text: "Through our partnership with Speedata, [AI] Platform delivers Apache Spark on purpose-built Analytics Processing Units, up to 100× faster than commodity cloud compute.",
    img: Hardware_accelerated_Icon,
  },
  {
    title: "Autonomous agents with guardrails",
    text: "Data Assistant and TradeTutor don't just analyse, they act. All within explicit, auditable, permission-scoped boundaries.",
    img: Autonomous_Agent_Icon,
  },
];

export const headerDropdown = [
  {
    label: "Platforms",
    lists: [
      {
        title: "[AI] Platform",
        text: "Orchestration of agents for enterprise decision-making.",
        icon: Agentic_Header_Icon,
        link: "/ai-platform",
      },
      {
        title: "Pulse",
        text: "Give your AI the context it needs",
        icon: PLM_Header_Icon,
        link: "/pllm",
      },
      {
        title: "CORE",
        text: "AI that doesn't just answer, it reasons",
        // icon: PLM_Header_Icon,
        icon: AI_Core_Icon,
        link: "/core",
      },

      {
        title: "Data Assistant",
        text: "An enterprise AI agent for analytics, delivering explainable insights.",
        link: "/data-assistant",
        icon: DA_Header_Icon,
      },
      {
        title: "TradeTutor",
        text: "Private fine-tuned models for analytics, keeping enterprise data secure.",
        link: "/tradetutor",
        icon: Trade_Icon,
      },
    ],
  },
  {
    label: "Solutions",
    lists: [
      {
        title: "For Capital Markets",
        text: "Empowering Investment Decisions with Intelligent LLMs and Real-Time Analytics Agents",
        icon: Capital_Market_Icon,
        link: "/solutions/capital-markets",
      },
      {
        title: "For Financial Markets",
        text: "Targeted insights and retail trader engagement.",
        icon: Financial_Header_Icon,
        link: "/solutions/financial-markets",
      },
      {
        title: "For Enterprises",
        text: "Becoming data-driven with secure LLMs and analytics agents.",
        icon: Enterprises_Header_Icon,
        link: "/solutions/enterprises",
      },
    ],
  },
  {
    label: "Technology",
    lists: [
      {
        title: "Infrastructure",
        text: "Private fine-tuned models, secure hosting, compliance",
        icon: Infrastructure_Header_Icon,
        link: "/technology#infrastructure",
      },
      {
        title: "Analytics Engine",
        text: "Built for explainability, precision, and scale.",
        icon: Analytics_Engine_Header_Icon,
        link: "/technology#analytics-engine",
      },
      {
        title: "Agent Framework",
        text: "Plug-and-play deployment of analytics-driven AI agents.",
        icon: Agent_Header_Icon,
        link: "/technology#agent-framework",
      },
    ],
  },
  {
    label: "Resources",
    lists: [
      {
        title: "Articles, Blogs, Whitepapers",
        text: "",
        icon: Article_Header_Icon,
        link: "/blog",
      },
      {
        title: "Events & Webinars",
        text: "",
        icon: Event_Header_Icon,
        link: "/event/ai-data-stack-connect-2025",
      },
    ],
  },
  {
    label: "Company",
    lists: [
      {
        title: "About Us",
        text: "",
        icon: Team_Header_Icon,
        link: "/about-us",
      },
      {
        title: "Partners",
        text: "",
        icon: Partnership_Icon,
        link: "/partners",
      },
      {
        title: "[AI] Academy",
        text: "",
        icon: AI_Academy_Icon,
        link: "https://www.myacademy.ai",
      },
      {
        title: "Careers",
        text: "",
        icon: Career_Header_Icon,
        link: "/careers",
      },
      {
        title: "FAQs",
        text: "",
        icon: FAQs_Header_Icon,
        link: "/faqs",
      },

      {
        title: "Contact",
        text: "",
        icon: Contact_Header_icon,
        link: "/contact",
      },
    ],
    image: null,
    imageTitle: "",
    imageText: "",
    icon: false,
  },
];

export const faqData = [
  {
    title: "What is [AI] Platform?",
    body: "[AI] Platform is enterprise analytics infrastructure powered by Speedata APUs and NVIDIA GPUs. It accelerates Apache Spark workloads, lowers analytics costs, and supports secure cloud or on-premises deployment.",
  },
  {
    title: "How does [AI] Platform accelerate Apache Spark?",
    body: "[AI] Platform uses Analytics Processing Units (APUs) built specifically for data analytics, enabling faster Spark processing, improved efficiency, and lower infrastructure costs than traditional CPU-based clusters.",
  },
  {
    title: "How much faster is [AI] Platform than standard cloud compute?",
    body: "[AI] Platform can run Apache Spark workloads up to 100× faster than traditional cloud-based Spark infrastructure, depending on workload requirements.",
  },
  {
    title: "Do I need to modify my existing Spark applications?",
    body: "No. [AI] Platform is fully compatible with existing Apache Spark workloads, allowing you to run current applications without code changes.",
  },
  {
    title: "How much can organisations save on analytics costs?",
    body: "Organisations can reduce query costs by up to 80% through hardware-accelerated analytics and more efficient resource utilisation.",
  },
  {
    title: "Can [AI] Platform be deployed on-premises?",
    body: "Yes. [AI] Platform supports both cloud and on-premises deployment, helping organisations meet data sovereignty, security, and compliance requirements.",
  },
  {
    title: "Which industries use [AI] Platform?",
    body: "[AI] Platform is ideal for financial services, healthcare, government, telecommunications, retail, technology, media, and other data-intensive industries.",
  },
  {
    title: "What is an Analytics Processing Unit (APU)?",
    body: "An APU is specialised hardware designed for analytics workloads. It processes data more efficiently than traditional CPUs, delivering significantly faster analytics performance.",
  },
  {
    title: "Does [AI] Platform support AI and machine learning?",
    body: "Yes. [AI] Platform includes NVIDIA GPU infrastructure for AI model training, inference, machine learning, and autonomous AI applications.",
  },
  {
    title: "What data sources can connect to [AI] Platform?",
    body: "[AI] Platform integrates with data lakes, data warehouses, cloud storage, streaming platforms, and existing enterprise analytics systems.",
  },
  {
    title: "How does [AI] Platform support data sovereignty?",
    body: "With cloud and on-premises deployment options, organisations maintain control over where data is stored, processed, and governed.",
  },
  {
    title:
      "What makes [AI] Platform different from traditional analytics infrastructure?",
    body: "Unlike general-purpose cloud compute, [AI] Platform combines purpose-built analytics hardware, Apache Spark acceleration, and NVIDIA GPU infrastructure to deliver faster performance and lower costs.",
  },
  {
    title: "Is [AI] Platform suitable for petabyte-scale analytics?",
    body: "Yes. [AI] Platform is built for enterprise-scale analytics and can process petabyte-scale datasets efficiently and securely.",
  },
  {
    title: "How do I get started?",
    body: "Contact our team to schedule a demo and discuss your analytics requirements.",
  },
];
